import { Button } from "common/src/styles";
import { BaseModal } from "../../../../common/BaseModal";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TITLE = "You're about to stake GTC on this project";
const TITLE_ROUND_VIEW = "You're about to stake GTC in this round!";
const DESCRIPTION = "To complete your stake, you’ll be redirected to a new tab. Once you confirm your transaction, your support will be reflected on the round page.";
const CHECK_POINTS = ["Boost this project’s visibility", "Earn a share of the 3% rewards pool"];
const Title = _ref => {
  let {
    isRoundView
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/_jsx("div", {
      className: "text-3xl leading-[2.125rem] align-middle font-medium",
      children: isRoundView ? TITLE_ROUND_VIEW : TITLE
    }), /*#__PURE__*/_jsx("div", {
      className: "text-base leading-[1.625rem] align-middle font-normal",
      children: DESCRIPTION
    })]
  });
};
const CheckPoints = () => /*#__PURE__*/_jsx("div", {
  className: "flex flex-col gap-4",
  children: CHECK_POINTS.map((point, index) => /*#__PURE__*/_jsx("div", {
    className: "text-base leading-[1.625rem] align-middle font-normal",
    children: `✅ ${point}`
  }, index + point))
});
const Content = _ref2 => {
  let {
    isRoundView
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-6 font-sans text-black",
    children: [/*#__PURE__*/_jsx(Title, {
      isRoundView: isRoundView
    }), /*#__PURE__*/_jsx(CheckPoints, {})]
  });
};
const ActionButtons = _ref3 => {
  let {
    onCancel,
    onStake
  } = _ref3;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex justify-center gap-6 font-mono font-medium text-sm leading-6",
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      $variant: "outline",
      className: `inline-flex text-black py-2 px-4`,
      onClick: onCancel,
      "data-testid": "modal-cancel",
      children: "Cancel"
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      className: `inline-flex bg-[#22635A] text-white py-2 px-4`,
      onClick: onStake,
      "data-testid": "modal-stake",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-2",
        children: ["Stake GTC ", /*#__PURE__*/_jsx(ArrowRightIcon, {
          className: "w-4 h-4 no-shrink"
        })]
      })
    })]
  });
};
export const StakingModal = _ref4 => {
  let {
    isOpen,
    onClose,
    onStake,
    isRoundView
  } = _ref4;
  return /*#__PURE__*/_jsx(BaseModal, {
    isOpen: isOpen,
    onClose: onClose,
    size: "2xl",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-8",
      children: [/*#__PURE__*/_jsx(Content, {
        isRoundView: isRoundView
      }), /*#__PURE__*/_jsx(ActionButtons, {
        onCancel: onClose,
        onStake: onStake
      })]
    })
  });
};